import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionHeartColorIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <circle cx="8.208" cy="8" r="8" fill="#E94545" />
    <path
      fill="#fff"
      d="m8.207 12.156-.644-.587c-2.29-2.076-3.8-3.445-3.8-5.125A2.42 2.42 0 0 1 6.207 4c.773 0 1.516.36 2 .929a2.661 2.661 0 0 1 2-.929 2.42 2.42 0 0 1 2.445 2.444c0 1.68-1.511 3.05-3.8 5.13l-.645.582Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.874 2.666h10.667v10.667H2.874z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionHeartColorIcon);
